import { render, staticRenderFns } from "./LoginFallback.vue?vue&type=template&id=b59c3318&"
import script from "./LoginFallback.vue?vue&type=script&lang=js&"
export * from "./LoginFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports